document.addEventListener("DOMContentLoaded", async function () {
  console.log("🚀 Predictive Search Loaded");

  const searchInput = document.querySelector("input[name='q']");
  const predictiveResultsContainer = document.getElementById(
    "predictive-search-results"
  );
  const loadingContainer = document.getElementById("predictive-search-loading");

  // If this page doesn't have the drawer, bail quietly
  if (!searchInput || !predictiveResultsContainer) {
    return;
  }

  // 🔹 Load full product index via search-index-loader.js
  let allProducts = [];
  if (typeof window.loadAllProducts === "function") {
    try {
      allProducts = await window.loadAllProducts();
      console.log("🔍 Predictive search index size:", allProducts.length);
    } catch (err) {
      console.error("🚨 Failed to load full search index:", err);
      allProducts = [];
    }
  } else {
    console.warn(
      "⚠️ window.loadAllProducts is not defined. Predictive search will rely only on Shopify API."
    );
  }

  async function fetchPredictiveSearchResults(query) {
    const trimmed = query.trim();
    if (!trimmed) {
      predictiveResultsContainer.innerHTML = "";
      if (loadingContainer) loadingContainer.classList.add("hidden");
      return;
    }

    if (loadingContainer) loadingContainer.classList.remove("hidden");

    try {
      const response = await fetch(
        `/search/suggest.json?q=${encodeURIComponent(
          trimmed
        )}&resources[type]=product,query,page&resources[limit]=10`
      );
      if (!response.ok) {
        throw new Error(`Fetch failed with status ${response.status}`);
      }

      const data = await response.json();
      console.log("🔍 Predictive Search API Response:", data);

      let products = (data.resources?.results?.products || []).map((product) => {
        const localMatch = allProducts.find(
          (p) => p.handle === product.handle
        );

        return {
          id: product.id,
          title: product.title || localMatch?.title || "Untitled",
          handle: product.handle,
          url: `/products/${product.handle}`,
          image:
            (product.image && product.image.src) ||
            localMatch?.image ||
            "/default-image.jpg",
          vendor: product.vendor || localMatch?.vendor || "Unknown",
          subtitle:
            product.metafields?.descriptors?.subtitle ||
            localMatch?.subtitle ||
            "",
          price:
            typeof product.price === "number"
              ? product.price
              : localMatch?.price || null,
        };
      });

      // Merge in any additional text matches from the full index
      if (allProducts.length > 0) {
        products = mergeSearchResults(products, trimmed, allProducts);
      }

      updatePredictiveSearchUI(products);
    } catch (error) {
      console.error("🚨 Error fetching predictive search results:", error);
      predictiveResultsContainer.innerHTML =
        "<p class='text-red-500'>Error fetching results.</p>";
    } finally {
      if (loadingContainer) loadingContainer.classList.add("hidden");
    }
  }

  function mergeSearchResults(products, query, allProducts) {
    const queryLower = query.toLowerCase();
    let mergedResults = [...products];

    allProducts.forEach((product) => {
      const searchableText = `
        ${product.title || ""}
        ${product.description || ""}
        ${Array.isArray(product.tags) ? product.tags.join(" ") : ""}
        ${product.subtitle || ""}
      `.toLowerCase();

      if (searchableText.includes(queryLower)) {
        const existingIndex = mergedResults.findIndex(
          (p) => p.id === product.id
        );

        const enrichedProduct = {
          id: product.id,
          title: product.title || "Untitled",
          handle: product.handle,
          url: `/products/${product.handle}`,
          image: product.image || "/default-image.jpg",
          vendor: product.vendor || "Unknown",
          subtitle: product.subtitle || "",
          price: product.price || null,
        };

        if (existingIndex !== -1) {
          mergedResults[existingIndex] = enrichedProduct;
        } else {
          mergedResults.push(enrichedProduct);
        }
      }
    });

    return mergedResults;
  }

  function updatePredictiveSearchUI(products) {
    // Basic filter to avoid junk entries
    products = products.filter(
      (product) => product.title && product.image && product.image !== "/default-image.jpg"
    );

    console.log("🔍 Final Rendered Products:", products);
    predictiveResultsContainer.innerHTML = "";

    if (products.length > 0) {
      predictiveResultsContainer.insertAdjacentHTML(
        "beforeend",
        `<h4 class="text-lg font-bold">Products</h4>`
      );
      products.forEach((product) => {
        const productHTML = `
          <a href="${
            product.url
          }" class="predictive-search-result group flex gap-4 py-2">
            ${
              product.image
                ? `<img src="${product.image}" alt="${product.title}" class="w-24 h-auto rounded-md">`
                : ""
            }
            <div class="v-stack gap-1 sm:gap-1.5">
              ${
                product.vendor
                  ? `<span class="text-xs text-subdued">${product.vendor}</span>`
                  : ""
              }
              <div class="v-stack justify-items-start gap-0.5">
                <span class="bold">
                  <span class="reversed-link">${product.title}</span>
                </span>
                ${
                  product.subtitle
                    ? `<p class="product-subtitle"><strong>Inspired by: </strong>${product.subtitle}</p>`
                    : ""
                }
                ${
                  typeof product.price === "number"
                    ? `<span class="text-sm font-semibold mt-1">$${(
                        product.price / 100
                      ).toFixed(2)}</span>`
                    : ""
                }
              </div>
            </div>
          </a>
        `;
        predictiveResultsContainer.insertAdjacentHTML("beforeend", productHTML);
      });
    } else {
      predictiveResultsContainer.innerHTML =
        "<p class='text-gray-500'>No results found.</p>";
    }
  }

  searchInput.addEventListener("input", (e) =>
    fetchPredictiveSearchResults(e.target.value)
  );

  // ✅ Safety for any "predictive-search-image" class you might use later
  setTimeout(() => {
    document.querySelectorAll(".predictive-search-image").forEach((img) => {
      if (!img.src || img.src.includes("[object Object]")) {
        img.src = "/default-image.jpg";
      }
    });
  }, 1000);
});
